import { Checkbox } from '@material-ui/core';
import * as React from 'react';
import { components } from 'react-select';
import { Text } from '../../../Text';
export const Option = (internalProps) => {
    const { label, value, testId } = internalProps;
    return (React.createElement(components.Option, Object.assign({}, internalProps),
        internalProps.isMulti && (React.createElement(Checkbox, { id: "autocomplete-multiselect-option-checkbox", checked: internalProps.isSelected, className: internalProps.selectProps.classes.checkboxRoot })),
        React.createElement(Text, { className: internalProps.selectProps.classes.optionText, ellipsis: true, testId: `${testId ? testId : value}-item` }, label)));
};
//# sourceMappingURL=Option.js.map